import moment from "moment/moment";

let DateFormatUnifier = {
    install(Vue, options) {
        Vue.unifyDateFormat = (data) => {
            let longFormats = [
                "YYYY-MM-DDTHH:mm:ss.SSSZ",
                "YYYY-MM-DD[T]HH:mm:ss.SSSZ",
                "YYYY-MM-DD[T]HH:mm:ss.SSSSSSZ",
                "MM/DD/YYYY HH*mm*ss",
                "YYYY-MM-DD HH:mm:ss",
                "YYYY-MM-DD HH:mm:ssZ"
            ];
            let shortFormats = [
                "YYYY-MM-DD"
            ];
            const momentDataLong = moment(data, longFormats, true)
            const momentDataShort = moment(data, shortFormats, true)
            if (momentDataLong.isValid()) {
                return momentDataLong.format('DD/MM/yyyy HH:mm:ss')
            } else if (momentDataShort.isValid()) {
                return momentDataShort.format('DD/MM/yyyy')
            } else {
                return data
            }
        };
    }
};

export default DateFormatUnifier;